import Breadcrumb from "components/Common/Breadcrumb2"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { withTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import List from "./Components/List"
import NewMultiUser from "./Components/NewMultiUser"
import NewUser from "./Components/NewUser"
import UpdateUser from "./Components/UpdateUser"

const Usuarios = props => {
  document.title = "Usuários | Sensetek"
  let { id } = useParams()
  const [activeTab, setActiveTab] = useState(id ? 3 : 0)
  const [reRenderList, setReRenderList] = useState(false)
  let history = useHistory()
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Usuários"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Usuários
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col>
                      <br className="mt-1" />
                      <Nav pills className="navtab-bg nav-justified">
                        {activeTab !== 0 && <div className="vr"></div>}
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            active={activeTab === 0}
                            onClick={() => {
                              setReRenderList(!reRenderList)
                              setActiveTab(0)
                              history.push("/configuracoes/acessos/usuarios")
                            }}
                          >
                            Lista de Usuários
                          </NavLink>
                        </NavItem>
                        {(activeTab === 2 || activeTab === 3) && (
                          <div className="vr"></div>
                        )}
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            active={activeTab === 1}
                            onClick={() => {
                              setActiveTab(1)
                              history.push("/configuracoes/acessos/usuarios")
                            }}
                          >
                            Criar em Lista
                          </NavLink>
                        </NavItem>
                        {(activeTab === 0 || activeTab === 3) && (
                          <div className="vr"></div>
                        )}
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            active={activeTab === 2}
                            onClick={() => {
                              setActiveTab(2)
                              history.push("/configuracoes/acessos/usuarios")
                            }}
                          >
                            Novo Usuário
                          </NavLink>
                        </NavItem>
                        {activeTab !== 2 && <div className="vr"></div>}
                      </Nav>
                      <TabContent
                        activeTab={activeTab}
                        className="p-3 text-muted"
                      >
                        <TabPane tabId={0}>
                          <Row>
                            <Col sm="12">
                              <List
                                reRender={reRenderList}
                                setNav={setActiveTab}
                              ></List>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId={1}>
                          <Row>
                            <Col sm="12">
                              <NewMultiUser
                                reRenderList={reRenderList}
                                setReRenderList={setReRenderList}
                                setNav={setActiveTab}
                              ></NewMultiUser>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId={2}>
                          <Row>
                            <Col sm="12">
                              <NewUser
                                reRenderList={reRenderList}
                                setReRenderList={setReRenderList}
                                setNav={setActiveTab}
                              ></NewUser>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId={3}>
                          <Row>
                            <Col sm="12">
                              {id && (
                                <UpdateUser
                                  reRenderList={reRenderList}
                                  setReRenderList={setReRenderList}
                                  setNav={setActiveTab}
                                ></UpdateUser>
                              )}
                            </Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Usuarios.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Usuarios)
